import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class CMSService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // WEBSITE MASTER------------------------------------------------------


  SaveWebsite(data, HeaderLogoPath, FooterLogoPath): Observable<any> {
    let formData = new FormData();
    formData.append("objWebsite", data);
    formData.append("HeaderLogo", HeaderLogoPath);
    formData.append("FooterLogo", FooterLogoPath);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/SaveWebsite', formData);
  }


  GetWebsite(strdata: any): Observable<any> {
    let Parameter = 'Obj=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/GetWebsite?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  // SLIDER MASTER

  GetSlider(strdata: any): Observable<any> {
    let Parameter = 'JOSAURLID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/GetSlider?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }
  SliderMarkActive(strdata: any): Observable<any> {
    let Parameter = 'objSlider=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/SliderMarkActive?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }
  SaveSlider(data, HeaderLogoPath): Observable<any> {
    let formData = new FormData();
    formData.append("objSlider", data);
    formData.append("Slider", HeaderLogoPath);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/SaveSlider', formData);
  }

  // SITE MAP

  SaveSiteMap(strdata: any): Observable<any> {
    let Parameter = 'objSiteMap=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/SaveSiteMap?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetSiteMap(): Observable<any> {

    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/GetSiteMap?',
      { headers: reqHeader });
  }

  SiteMapMarkActive(strdata): Observable<any> {
    let Parameter = 'objSiteMap=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/SiteMapMarkActive?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetAccountSiteMap(strdata: any): Observable<any> {
    let Parameter = 'JOSAURLID=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/GetAccountSiteMap?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  SaveAccountSiteMap(data, list): Observable<any> {

    let formData = new FormData();
    formData.append("JOSAURLID", data);
    formData.append("objSiteMap", list);

    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/SaveAccountSiteMap', formData);
  }

  // JOSA URL

  GetAllJosaUrl(strdata: any): Observable<any> {
    let Parameter = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/GetAllJosaUrl?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  SaveJosaURlStatus(strdata: any): Observable<any> {
    let Parameter = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/SaveJosaURlStatus?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  UpdateJOSAURL(strdata: any): Observable<any> {
    let Parameter = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'CMS/UpdateJOSAURL?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  
}

